module.exports = __webpack_public_path__ + "static/img/noSwiperImg1.0b96dba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newImage/noSwiperImg1.png
// module id = ky1b
// module chunks = 3